"use client";

import React from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hero-section" className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-slate-950">
      {}
      <div className="absolute inset-0 z-0">
        <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626429/img/bathroom_renovation_workspace_blue.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626429/img/bathroom_renovation_workspace_blue.png-wvc-sizes" alt="Professional bathroom renovation workspace in Karlstad" className="w-full h-full object-cover opacity-70" fetchpriority="high" loading="eager" src="https://proffsbadrum.se/wp-content/uploads/2026/09/Karlstad.Hero_120kb.webp" />
        {}
        <div className="absolute inset-0 bg-slate-950/60" />
        <div className="absolute inset-0 bg-primary/10 mix-blend-color" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-transparent to-transparent" />
      </div>

      {}
      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center text-center pt-20 pb-32">
        <div ref={ref} className={`max-w-4xl mx-auto transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h1 className="font-default text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-6 tracking-tight drop-shadow-md">Badrumsrenovering Karlstad – Komplett totalentreprenad</h1>
          
          <p className="text-lg md:text-xl lg:text-2xl text-white/90 max-w-3xl mx-auto mb-10 leading-relaxed drop-shadow">Proffsbadrum hjälper dig hela vägen när du ska renovera badrum i Karlstad. Med fast pris och samordnad totalentreprenad tar vi hand om projektet från planering och rivning till VVS, tätskikt, plattsättning och färdigt badrum.</p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/offertforfragan">
              <Button size="lg" className="text-base md:text-lg px-8 py-6 h-auto rounded-md shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                Få ett personligt prisförslag
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <ChevronDown className="w-8 h-8 text-white/60" aria-hidden="true" />
      </div>
    </section>;
}